module.exports = __webpack_public_path__ + "img/10.7b9aef19.jpg";